<template>
	<NuxtLayout name="one-column-layout">
		<template #title>
			<div class="flex flex-col gap-8 text-center">
				<div class="text-3xl sm:text-4xl">{{ $t("maintenance1") }}</div>

				<img
					v-if="runtimeConfig.public.DEFAULT_MAINTENANCE_IMAGE"
					class="mx-auto rounded-xl h-48 sm:h-1/4 w-full sm:w-1/2 object-cover border-2 border-primary"
					:src="runtimeConfig.public.DEFAULT_MAINTENANCE_IMAGE" />

				<p class="text-2xl sm:text-3xl">
					{{ $t("maintenance2") }}
				</p>
			</div>
		</template>

		<template #contentSlot1>
			<NuxtLink
				v-if="url"
				:to="url"
				class="rounded-3xl">
				<ButtonPrimary class="mt-4">
					<p>{{ $t("maintenanceBtn") }}</p>
				</ButtonPrimary>
			</NuxtLink>
		</template>
	</NuxtLayout>
</template>

<script setup>
	//This page relies on the showShoppingHeader logic in BasicHeader to show/hide the header objects
	const runtimeConfig = useRuntimeConfig()
	const url = runtimeConfig.public.MAINTENANCE_PAGE_BTN
</script>

<style lang="scss" scoped></style>
